import highlighted from "../plugins/highlighted";

const GoogleMap = {
  addHiglight(map) {
    let paths = [];

    highlighted.forEach(function (country) {
      if (country.geometry.coordinates.length === 1) {
        paths.push(country.geometry.coordinates[0]);
      } else {
        country.geometry.coordinates.forEach(function (group) {
          paths.push(group[0]);
        });
      }
    });

    paths.forEach(function (group, gindex) {
      paths[gindex].forEach(function (location, lindex) {
        paths[gindex][lindex] = new google.maps.LatLng(
          location[1],
          location[0]
        );
      });
    });

    let countries = new google.maps.Polygon({
      paths: paths,
      strokeColor: "#ffffff",
      strokeOpacity: 1,
      strokeWeight: 2,
      fillColor: "#C39F71",
      fillOpacity: 0.4,
    });

    countries.setMap(map);
  },
};

export default GoogleMap;
